var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    color: "#115E67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 875 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.33333C4 5.59695 4.59695 5 5.33333 5H10.6667C11.403 5 12 5.59695 12 6.33333V11.6667C12 12.403 11.403 13 10.6667 13H5.33333C4.59695 13 4 12.403 4 11.6667V6.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 875",
    d: "M6.66675 7.6665H9.33341V10.3332H6.66675V7.6665Z",
    fill: "#C9E1E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.dd1a1e5c0e2b4adb0b5be20f5adc581d.svg";
export { ForwardRef as ReactComponent };